import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { SummaryCardHelp } from '~/modules/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1)
  }
}));

const getKPIContent = ({ formatMessage, canViewBIIndex, canViewSPIIndex }) => [
  {
    title: formatMessage({ id: 'projectKPI.timesheetComplianceIndex.label' }),
    message: formatMessage({
      id: 'projectKPI.timesheetComplianceIndex.description'
    })
  },
  ...(canViewBIIndex
    ? [
        {
          title: formatMessage({ id: 'projectKPI.billabilityIndex.label' }),
          message: formatMessage({
            id: 'projectKPI.billabilityIndex.description'
          })
        }
      ]
    : []),
  ...(canViewSPIIndex
    ? [
        {
          title: formatMessage({
            id: 'projectKPI.schedulePerformanceIndex.label'
          }),
          message: formatMessage({
            id: 'projectKPI.schedulePerformanceIndex.description'
          })
        }
      ]
    : [])
];

const ProjectKPISummaryChartHelp = ({ projectKPIChartDataProps }) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const {
    projectPermissions: { canViewTasks, canViewProjectBillingData },
    isExpenseProductEnabled
  } = projectKPIChartDataProps;

  const toolTipContent = getKPIContent({
    formatMessage,
    canViewBIIndex: canViewProjectBillingData && isExpenseProductEnabled,
    canViewSPIIndex: canViewTasks
  });

  return (
    <div className={classes.root}>
      <SummaryCardHelp content={toolTipContent} />
    </div>
  );
};

ProjectKPISummaryChartHelp.propTypes = {
  projectKPIChartDataProps: PropTypes.object.isRequired
};

export default ProjectKPISummaryChartHelp;
